import { Button, Col, message, ModalProps, Radio, Row } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { Link, useLocation } from 'react-router-dom';
import {
  checkPaymentMethod,
  getDetailSubcriptionOrder,
  paymentSubcriptionData,
  waitForLoadDataJob,
} from 'src/api/register_and_cancel_and_load_package';
import BoxWithLabel from 'src/components/BoxWithLabel/BoxWithLabel';
import Loading from 'src/components/CLoading';
import ModalConfirm from 'src/components/modals/ModalComfirm';
import { usePermission } from 'src/hooks/usePermission';
import { useAppDispatch, useAppSelector } from 'src/redux/hook';
import { setGlobalState } from 'src/redux/slice/globalSlice';
import { resetModalState, setModalState } from 'src/redux/slice/modal.store';
import { OrderStatusEnum } from 'src/shared/enum/package_assigned';
import { TransactionHistory } from 'src/shared/interface/localpay.interface';
import { IPayBillOrderSubcription } from 'src/shared/interface/register_and_cancel_and_load';
import { convertNumberByUnit, formatDateTime, formatMoney, useRenderLinkDirectTo } from 'src/utils';
import { useOpenMenuTab } from 'src/utils/openMenuTab';

interface ModalTopUpProps extends ModalProps {
  selectedHistory?: TransactionHistory;
}
interface IDetailLine {
  mbfCode: string;
  toTalAmount: number;
  countItem: number;
  dataGb: string;
  discountAmount: number;
}
function LoadDataBillingModal({ selectedHistory }: ModalTopUpProps) {
  const dispatch = useAppDispatch();
  const [paymentMethod, setPaymentMethod] = useState<string[]>([]);
  const { order, refresh, balance, balanceData } = useAppSelector((state) => state.global);
  const { dataEnterprise } = useAppSelector((state) => state.userProfile);
  const merchantInfo: string | null = localStorage.getItem('merchantInfo');
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [totalGb, setTotalGb] = useState<number>(0);
  const [paymentMethodVal, setPaymentMethodVal] = useState<number>(1);
  const [dataDetailLine, setDataDetailLine] = useState<IDetailLine[]>([]);
  const currentPath = useLocation();
  const { openMenuTab } = useOpenMenuTab();

  const { hasAllPermissions, PERMISSIONS } = usePermission();

  async function handlePayBill() {
    setIsModalLoading(true);
    setOpenModalConfirm(false);
    if (merchantInfo) {
      const data: IPayBillOrderSubcription = {
        orderId: order?.id ? order?.id : '',
        paymentMethod: paymentMethodVal === 1 ? 'LocalPay' : 'DataAccount',
      };
      try {
        const jobRes = await paymentSubcriptionData(data);
        if (jobRes) {
          const res = await waitForLoadDataJob(jobRes.jobId, 'payment');
          if (res) {
            dispatch(setGlobalState({ refresh: !refresh }));
            dispatch(setModalState({ open: false }));
            message.success({
              content:
                'Thanh toán thành công! Hệ thống đang thực hiện nạp data, vui lòng chờ ít phút !',
              duration: 4,
            });
          }
        } else {
          dispatch(
            setGlobalState({
              contentModal: `${jobRes.errorMessage}`,
              titleModal: 'Thông báo !',
              visibleModal: true,
            }),
          );
        }
      } catch (error) {
        console.log(error);
      }
    }
    setIsModalLoading(false);
    dispatch(setGlobalState({ refresh: !refresh }));
  }

  const fetchDetailOrder = async (id: string) => {
    const res = await getDetailSubcriptionOrder(id);
    if (res) {
      dispatch(setGlobalState({ order: res }));
    }
  };

  const fetchPaymentMethod = async () => {
    const res = await checkPaymentMethod();
    if (res) {
      setPaymentMethod(res);
    }
  };
  useEffect(() => {
    if (selectedHistory) {
      fetchDetailOrder(selectedHistory.id || selectedHistory.paymentId);
    }
    fetchPaymentMethod();
  }, [selectedHistory]);

  useEffect(() => {
    if (order) {
      order?.paymentMethod === 'DataAccount' ? setPaymentMethodVal(2) : setPaymentMethodVal(1);
      const listDataDetail: {
        mbfCode: string;
        toTalAmount: number;
        countItem: number;
        dataGb: string;
        discountAmount: number;
      }[] = [];

      order?.overFlowOrderDetailResponses?.forEach((item: any) => {
        if (item?.statusString !== OrderStatusEnum.Failed) {
          const findIndexTopup = listDataDetail.findIndex(
            (predicate) => predicate.mbfCode === item?.mbfCode,
          );
          if (findIndexTopup === -1) {
            listDataDetail.push({
              mbfCode: item.mbfCode,
              toTalAmount: item.price,
              countItem: 1,
              dataGb: item.extraDataObject?.dataGb,
              discountAmount: item.extraDataObject?.discountAmount,
            });
          } else {
            listDataDetail[findIndexTopup] = {
              ...listDataDetail[findIndexTopup],
              countItem: listDataDetail[findIndexTopup].countItem + 1,
              toTalAmount: listDataDetail[findIndexTopup].toTalAmount + item.price,
              discountAmount:
                listDataDetail[findIndexTopup]?.discountAmount +
                item.extraDataObject?.discountAmount,
            };
          }
        }
      });
      const totalDataGb = listDataDetail?.reduce((sum: number, item: any) => {
        const value = Number(item.dataGb ? Number(item.dataGb) * item.countItem : 0) || 0;
        return sum + value;
      }, 0);
      setTotalGb(totalDataGb || 0);
      setDataDetailLine(listDataDetail);
    }
  }, [order]);

  const renderInterpretation = () => {
    if (currentPath.pathname.includes('transaction')) {
      return 'Nạp data';
    } else if (currentPath.pathname.includes('localpay')) {
      return 'Trừ tiền Nạp data';
    } else {
      return 'Thanh toán đơn hàng Nạp data';
    }
  };

  const handleOpenMenuTab = () => {
    if (selectedHistory) {
      openMenuTab({ selectedHistory });
    }
  };

  const isShowBalance = () => {
    if (currentPath.pathname.includes('transaction') || currentPath.pathname.includes('localpay'))
      return false;
    if (currentPath.pathname.includes('data-load')) {
      if (order?.statusString === OrderStatusEnum.New) return true;
      return false;
    }
    return true;
  };

  const isShowButtonPay = () => {
    const balanceDataGB = convertNumberByUnit(balanceData, 'KB', 'GB');
    if (paymentMethodVal === 2 && totalGb > +balanceDataGB) {
      return false;
    }
    return true;
  };
  return (
    <Fragment>
      {isModalLoading && <Loading />}
      <div className='flex justify-end'>
        <button
          onClick={() => dispatch(resetModalState())}
          className=' text-3xl cursor-pointer border-transparent bg-transparent'
        >
          <RxCross2 />
        </button>
      </div>
      <BoxWithLabel
        title={
          currentPath.pathname.includes('transaction') || currentPath.pathname.includes('localpay')
            ? 'Thông tin giao dịch'
            : 'Thông tin thanh toán'
        }
        classNames='mb-[1.5rem]'
      >
        <Row gutter={[16, 16]}>
          <Col span={24} md={12}>
            Mã giao dịch: {order?.transactionId}
          </Col>
          <Col span={24} md={12}>
            Người thanh toán: {merchantInfo ? JSON.parse(merchantInfo).merchantName : '-'}
          </Col>
          <Col span={24} md={12}>
            Ngày thanh toán:{' '}
            {order?.transactionDate && new Date(order?.transactionDate).getFullYear() > 1900
              ? formatDateTime(order.transactionDate)
              : formatDateTime(new Date())}
          </Col>
          <Col span={24} md={12}>
            Đơn hàng tham chiếu:{' '}
            <Link
              onClick={(e) => {
                e.preventDefault();
                dispatch(resetModalState());
                handleOpenMenuTab();
              }}
              className='hover:underline underline'
              to={useRenderLinkDirectTo({
                id: selectedHistory?.paymentId || selectedHistory?.id,
                type: selectedHistory?.type,
              })}
            >
              {order?.id}
            </Link>
          </Col>
          <Col span={24} md={12}>
            Diễn giải: {renderInterpretation()}
          </Col>
        </Row>
        <p className='font-bold mb-[0.5rem]'>Chi tiết hóa đơn:</p>
        <div className='normal-table max-h-96 overflow-y-auto'>
          <table width='100%' className='normal-table'>
            <thead>
              <tr>
                <th>STT</th>
                <th>Số lượng</th>
                <th>Mã hàng</th>
                <th>Dung lượng</th>
                <th>Tổng tiền</th>
                <th>Tiền chiết khấu</th>
                <th>Thành tiền</th>
              </tr>
            </thead>
            <tbody>
              {dataDetailLine.map((predicate, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{predicate.countItem ?? 1}</td>
                    <td>{predicate?.mbfCode ? predicate?.mbfCode : ''}</td>
                    <td>
                      {predicate?.dataGb
                        ? `${Number(predicate.dataGb) * predicate.countItem} GB`
                        : ''}
                    </td>
                    <td>
                      {predicate?.toTalAmount ? formatMoney(predicate?.toTalAmount, 'đ') : '-'}
                    </td>
                    <td>
                      {predicate?.toTalAmount ? formatMoney(predicate?.discountAmount, 'đ') : '0đ'}
                    </td>
                    <td>
                      {predicate?.toTalAmount
                        ? predicate?.discountAmount
                          ? formatMoney(predicate?.toTalAmount - predicate?.discountAmount, 'đ')
                          : formatMoney(predicate?.toTalAmount, 'đ')
                        : '-'}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td></td>
                <td></td>
                <td className='font-semibold'>Tổng cộng</td>
                <td className='font-semibold'>{`${totalGb} GB`}</td>
                <td colSpan={2}></td>
                <td className='font-semibold'>
                  {order?.toTalAmount ? formatMoney(order?.toTalAmount, 'đ') : '0 đ'}
                </td>
              </tr>
              <tr>
                <td colSpan={3}></td>
                <td>
                  <div className='font-normal'>
                    {`(Tương đương ${convertNumberByUnit(totalGb, 'GB', 'KB')} KB)`}
                  </div>
                </td>
                <td colSpan={3}></td>
              </tr>
            </tbody>
          </table>
        </div>
      </BoxWithLabel>
      <BoxWithLabel title='Hình thức thanh toán' classNames='mb-[1.5rem]'>
        <Radio.Group
          value={paymentMethodVal}
          className='mb-3'
          onChange={(e) => {
            if (
              order?.statusString === OrderStatusEnum.PAYMENT_FAIL ||
              order?.statusString === OrderStatusEnum.New
            ) {
              setPaymentMethodVal(e.target.value);
            }
          }}
        >
          {paymentMethod &&
            paymentMethod.length > 0 &&
            paymentMethod.map((val: string, index: number) => (
              <Radio key={index} value={index + 1}>
                {val === 'LocalPay' ? 'Localpay' : 'Tài khoản data'}
              </Radio>
            ))}
        </Radio.Group>
        <Row gutter={[16, 16]}>
          <Col span={24} md={12} lg={isShowBalance() ? 8 : 12}>
            Mã tài khoản:{' '}
            {merchantInfo
              ? paymentMethodVal === 1
                ? JSON.parse(merchantInfo).payAccountId
                : JSON.parse(merchantInfo).payAccountData
              : '-'}
          </Col>
          <Col span={24} md={12} lg={isShowBalance() ? 8 : 12}>
            Tên chủ tài khoản:{' '}
            {paymentMethodVal === 1
              ? merchantInfo
                ? JSON.parse(merchantInfo).merchantName
                : '-'
              : dataEnterprise?.customer_name ?? '-'}
          </Col>
          {isShowBalance() && (
            <Col span={24} md={12} lg={8}>
              Số dư:{' '}
              {paymentMethodVal === 1
                ? balance
                  ? formatMoney(balance, 'đ')
                  : '-'
                : `${convertNumberByUnit(balanceData, 'KB', 'GB', 'vi-VN')} GB`}
            </Col>
          )}
        </Row>
      </BoxWithLabel>
      <Row gutter={[16, 16]} className='w-full'>
        <Col span={24} md={12}>
          Người tạo: {order?.createdBy}
        </Col>
        <Col span={24} md={12}>
          Ngày tạo: {order?.createdAt ? formatDateTime(order?.createdAt) : '-'}
        </Col>
      </Row>
      {/* Nếu số dư tài khoản Data đủ đề cấn trừ, thì Hiện nút “Thanh toán”, nếu không , ẩn nút “Thanh Toán (Phase 2)” */}
      {(order?.statusString === OrderStatusEnum.PAYMENT_FAIL ||
        order?.statusString === OrderStatusEnum.New) &&
        isShowButtonPay() &&
        hasAllPermissions(
          PERMISSIONS.PACKAGE_MANAGEMENT.LOAD_DATA_CREATE_PAYMENT,
          PERMISSIONS.PACKAGE_MANAGEMENT.LOAD_DATA_PAYMENT_DATA,
        ) && (
          <div className='row-button justify-end mt-4'>
            <Button onClick={() => setOpenModalConfirm(true)}>Thanh toán</Button>
          </div>
        )}
      <ModalConfirm
        open={openModalConfirm}
        content={
          <div className='pb-0 p-7'>
            <div className='font-black text-3xl mb-4'>Xác nhận thanh toán và nạp data?</div>
            <p>
              Bạn có chắc chắn muốn trừ {paymentMethodVal === 1 ? 'localpay' : 'tài khoản data'} và
              nạp cho thuê bao ?
            </p>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              <Button onClick={handlePayBill} className='h-full w-full' disabled={isModalLoading}>
                Xác nhận
              </Button>
              <Button
                className='h-full w-full'
                onClick={() => {
                  setOpenModalConfirm(false);
                }}
              >
                THOÁT
              </Button>
            </div>
          </div>
        }
      />
    </Fragment>
  );
}

export default LoadDataBillingModal;
